import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollToTopButton from "@/components/feature/ScrollToTopButton";
import PageTransitionWrapper from "@/components/feature/PageTransitionWrapper";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <PageTransitionWrapper>
        <AppRoutes />
      </PageTransitionWrapper>
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;
